import { selectFeatureIncludes, FeatureDict } from '@authed/selectors'
import { Role } from '@global/types'
import { useAppSelector } from '@redux/hooks'

export const useApprovalsEnabled = () => {
  const user = useAppSelector(state => state.Auth.user)
  const account = useAppSelector(state => state.Auth.account)
  const features = useAppSelector(state => state.Auth.features)
  const [MANAGER_APPROVAL_ENABLED] = useAppSelector(
    selectFeatureIncludes([FeatureDict.MANAGER_APPROVALS]),
  )

  const APPROVAL_ENABLED = Boolean(features?.approval)
  const ALLOWS_APPROVAL = Boolean(account?.allow_approval)
  const isAdmin = user?.role === Role.OWNER
  const isManagerThatCanApprove = user?.role === Role.MANAGER && MANAGER_APPROVAL_ENABLED
  const isApprovalsEnabled =
    APPROVAL_ENABLED && (isAdmin || isManagerThatCanApprove) && ALLOWS_APPROVAL

  return isApprovalsEnabled ?? false
}
